import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const Title = styled.h1`
  ${({ theme }) => typographyToCss(theme.typography.h5)};
  flex: 1;
  display: block;

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.palette.text.primary};

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const CenterInteractions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const TimeSelectionContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing(0.5)};

  border-radius: ${({ theme }) => theme.spacing(2.5)};
  background: ${({ theme }) => theme.palette.grey[100]};
`;

export const TimeSelectionButton = styled.button<{ $rotated?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0;
  padding: 0;
  width: 2.2rem;
  height: 2.2rem;

  border-radius: ${({ theme }) => theme.spacing(2)};
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 200ms;
  -webkit-app-region: no-drag;

  font-size: 1.4rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[700]};

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }

  ${({ $rotated }) =>
    $rotated &&
    css`
      transform: rotate(180deg);
    `};
`;

export const Interactions = styled.div<{ $selected: boolean }>`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1.5)};

  white-space: nowrap;
  color: ${({ theme, $selected }) =>
    $selected ? theme.palette.text.primary : theme.palette.grey[700]};
`;
